import React from "react";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 Report Cards pages (Dashboard and
// Report Cards). The Dashboard / Report Cards / SBG tab strip and the term
// dropdown are handed across the v1/v2 bridge as data + callbacks: onNavigate
// routes the same-SPA tabs client-side, the SBG tab is a hard nav into v2, and
// onTermChange pushes the new term back into v1 state. (This header stays
// v1-sourced: unlike School Profile / Staff / Scheduling, its Dashboard/Report
// Cards/SBG mix spans the v1/v2 split and the registry's report-cards group does
// not model the exact cross-app link set.)
export default function ReportCardsHeader({
  activeKey,
  dashboardUrl,
  reportCardsUrl,
  sbgUrl,
  showSbgReportCards,
  terms,
  selectedTermId,
  onTermChange,
  onNavigate,
}) {
  // Dashboard / Report Cards stay in the v1 SPA (onNavigate, client-side); SBG
  // Report Cards is a hard nav into the v2 app (href). The SBG tab shows when the
  // school has it enabled or it is the active page, and is disabled if its URL is
  // not ready. The active tab never navigates.
  const showSbg = showSbgReportCards || activeKey === "sbg";
  const tabs = [
    {
      key: "dashboard",
      label: "Dashboard",
      onClick:
        activeKey === "dashboard" ? undefined : () => onNavigate(dashboardUrl),
    },
    {
      key: "report-cards",
      label: "Report Cards",
      onClick:
        activeKey === "report-cards"
          ? undefined
          : () => onNavigate(reportCardsUrl),
    },
    ...(showSbg
      ? [
          {
            key: "sbg",
            label: "SBG Report Cards",
            href: activeKey === "sbg" ? undefined : sbgUrl ?? undefined,
            disabled: activeKey !== "sbg" && !sbgUrl,
          },
        ]
      : []),
  ];

  return (
    <PageHeader
      title="Report Cards"
      termSelector={{ terms, value: selectedTermId, onChange: onTermChange }}
      tabs={tabs}
      activeTab={activeKey}
    />
  );
}
